"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _react = _interopRequireDefault(require("react"));

var _formik = require("formik");

var _isFunction = _interopRequireDefault(require("lodash/isFunction"));

var _utils = require("../../../../utils");

var AvatarField = function AvatarField(_ref) {
  var name = _ref.name,
      avatar = _ref.avatar,
      onChange = _ref.onChange;

  function handleUpload(_x, _x2) {
    return _handleUpload.apply(this, arguments);
  }

  function _handleUpload() {
    _handleUpload = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(e, formProps) {
      var target, file, dataURL;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              target = e.target;

              if (!target.files.length) {
                _context.next = 8;
                break;
              }

              file = e.target.files[0];
              _context.next = 5;
              return (0, _utils.compressImage)(file);

            case 5:
              dataURL = _context.sent;
              formProps.setFieldValue(name, dataURL);

              if ((0, _isFunction["default"])(onChange)) {
                onChange(name, dataURL);
              }

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _handleUpload.apply(this, arguments);
  }

  return /*#__PURE__*/_react["default"].createElement("label", {
    className: "relative overflow-hidden rounded-full flex-shrink-0"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "absolute py-1 w-full text-center text-xs bottom-0 cursor-pointer select-none z-10",
    style: {
      backgroundColor: 'rgba(0,0,0,.5)'
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "opacity-100 text-white"
  }, "Edit")), /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: name,
    render: function render(_ref2) {
      var field = _ref2.field,
          form = _ref2.form;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, avatar, /*#__PURE__*/_react["default"].createElement("input", {
        name: name,
        type: "file",
        accept: "image/*",
        className: "hidden",
        onChange: function onChange(e) {
          handleUpload(e, form);
        }
      }));
    }
  }));
};

var _default = AvatarField;
exports["default"] = _default;
//# sourceMappingURL=Avatar.js.map